import { useDispatch, useSelector } from "react-redux";
import { checkContent } from "../../../store/actions/admin/content-actions";
import { EventsState } from "../../../store/types";
import { FontPack } from "../../../types/working-model";
import classNames from 'classnames';
import { ListGridCheckbox } from "./document-item";
import { FontHelmet } from "../create/settings/design/fonts/font";

interface FontItemProps {
	font: FontPack;
}

export default function FontItem({ font }: FontItemProps):JSX.Element {
	const {
		ContentReducer: {
			checkedSet,
			view
		},
	} = useSelector((state: EventsState) => state);
	const dispatch = useDispatch();

	const handleCheck = () => dispatch(checkContent(font.font_pack));
	const isChecked = checkedSet.has(font.font_pack);
	const listView = view === "list";
	const gridView = view === "grid";
	const uploadedAt = new Date(font.created_at).toLocaleDateString();

	return (
		<li id={`font-${font.font_pack}`} className={classNames("content-item font", `${view}-item`)}>
			<ListGridCheckbox isChecked={isChecked} onChange={handleCheck} id={font.font_pack} gridView={gridView} />
			<h6 className="item-title grid-span" style={{ fontFamily: `var(--var-head), sans-serif` }}>{font.title}</h6>
			{gridView && <p style={{ fontFamily: `var(--var-body), sans-serif` }}>{font.description}</p>}

			{listView && (<>
				<p>{uploadedAt}</p>
				<hr className="hr" />
			</>)}

			<FontHelmet font={font} />
		</li>
	);
}